import {GraphValues} from './axisDataFromGraphValues';

export const normalizeGraphValues = (graphValues: GraphValues): GraphValues => {
    const maxSpeedBuffer: number = 0.2; // Should be replaced with a relative value, but works for now.
    const yValues: number[] = graphValues.map((d) => d.y);
    const yMin: number = Math.min.apply(0, yValues);
    const yMax: number = Math.max.apply(0, yValues);
    const yScale: number = 1 / (yMax + maxSpeedBuffer - yMin);
    return graphValues.map((d) => {
        return {x: d.x, y: d.y < 0 ? 0 : (d.y - yMin) * yScale};
    });
};
